import React, { useState, useEffect, useCallback } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    const y = window.scrollY;
    setIsScrolled(y > 50);

    // Show logo after 10% of total scrollable height
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    const threshold = scrollable * 0.1;
    setShowLogo(y >= threshold && threshold > 0);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const navLinks = [
    { href: '#lounge-section', label: 'Saale Lounge' },
    { href: '#beach-section', label: 'Saale Beach' },
    { href: '#menu', label: 'Karte Lounge' },
    { href: '#beach-menu', label: 'Karte Beach' },
    { href: '#reservation', label: 'Reservieren' },
    { href: '#contact', label: 'Kontakt' },
    { href: '#impressum', label: 'Impressum' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-bg-dark/95 backdrop-blur-md shadow-lg shadow-neon-pink/10' 
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <a 
            href="#" 
            className="text-2xl md:text-3xl font-bold text-neon-pink neon-text transition-opacity duration-500"
            style={{ 
              fontFamily: "'Great Vibes', cursive",
              WebkitTextStroke: '1.5px white',
              paintOrder: 'stroke fill',
              opacity: showLogo ? 1 : 0,
              pointerEvents: showLogo ? 'auto' : 'none'
            }}
          >
            Saale Lounge
          </a>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-white hover:text-neon-pink transition-colors duration-300 text-lg"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}
              >
                {link.label}
              </a>
            ))}
          </div>
          
          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-neon-pink"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        
        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-neon-pink/20">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-white hover:text-neon-pink transition-colors duration-300 text-lg"
                  style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 500 }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
